import MarkHomeworkDayView from './component';
import _routes from './routes';

export const routes = _routes;
export default MarkHomeworkDayView;



// WEBPACK FOOTER //
// ./containers/Group/Homework/PaperBased/MarkHomeworkDayView/index.js